var parent = require('../../actual/array/is-array');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/array/is-array.js
// module id = 540
// module chunks = 0 1